import React from "react";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";

const ButtonWrapper = styled.div<{ variant: IconButtonVariant; size: IconButtonVariantSize; disabled: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    ${({ size }) => {
        switch (size) {
            case "small":
                return `height: 30px; width: 30px;`;
            case "normal":
                return `height: 50px; width: 50px;`;
            case "large":
                return `height: 90px; width: 90px;`;
        }
    }}

    padding: inherit;
    cursor: ${(props: { disabled: boolean }) => (props.disabled ? "not-allowed" : "pointer")};
    opacity: ${(props: { disabled: boolean }) => (props.disabled ? "50%" : "100%")};
    background-color: ${(props) => props.theme.backgroundPrimary};

    ${({ variant }) => {
        switch (variant) {
            case "normal":
                return `border-radius: 10%;`;
            case "circle":
                return `border-radius: 50%;`;
        }
    }}

    &:hover {
        background-color: ${(props) => props.theme.hoverPrimary};
    }
`;

type IconButtonVariant = "normal" | "circle";
type IconButtonVariantSize = "small" | "normal" | "large";

interface IconButtonV2Props {
    children: JSX.Element;
    onClick: () => void;
    variant: IconButtonVariant;
    size: IconButtonVariantSize;
    disabled?: boolean;
    tooltip?: { tip: string; tipId: string; tipPlace?: "top" | "bottom" | "left" | "right" };
    className?: string;
}
function IconButton(props: IconButtonV2Props) {
    return (
        <ButtonWrapper
            onClick={props.onClick}
            className={props.className}
            variant={props.variant}
            size={props.size}
            disabled={props.disabled ?? false}
            data-for={props.tooltip?.tipId}
            data-tip={props.tooltip?.tip}
        >
            {props.children}
            {props.tooltip && <ReactTooltip id={props.tooltip.tipId} place={props.tooltip.tipPlace} />}
        </ButtonWrapper>
    );
}
export default IconButton;
